import { render, staticRenderFns } from "./project-progression-report.vue?vue&type=template&id=02bfd7dc&scoped=true"
import script from "./project-progression-report.vue?vue&type=script&lang=js"
export * from "./project-progression-report.vue?vue&type=script&lang=js"
import style0 from "./project-progression-report.vue?vue&type=style&index=0&id=02bfd7dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bfd7dc",
  null
  
)

export default component.exports